import { NavbarMenu } from '@root/core/interfaces';

export const ADMIN_BUSK_MENU: NavbarMenu[] = [
  {
    name: '대시보드',
    url: '/admin/busk'
  },
  {
    name: '셀러 관리',
    url: '/admin/busk/sellers'
  },
  {
    name: '물류센터 관리',
    url: '/admin/busk/logistic'
  },
  {
    label: '포워딩 업체 관리',
    children: [
      { name: '포워딩 업체 조회', url: '/admin/busk/forwarding' },
      { name: '포워딩 업체 등록', url: '/admin/busk/forwarding/create' }
    ]
  },
  {
    name: '재고 관리',
    url: '/admin/busk/stock'
  },
  {
    label: '정산 관리',
    children: [
      { id: 1, name: '정산 진행상황 조회', url: '/admin/busk/settlement' },
      {
        id: 2,
        name: '물류센터 정산 조회 ',
        url: '/admin/busk/warehouse-settlement'
      }
    ]
  },
  {
    name: '외부 api 송출 내역',
    url: '/admin/busk/api-import'
  }

  // {
  //   label: "정산/통계",
  //   children: [
  //     { id: 1, name: "aa", url: "#" },
  //     { id: 2, name: "bb", url: "#" },
  //     { id: 3, name: "dd", url: "#" },
  //   ],
  // },
];
